import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Rozcesti from './components/Rozcesti';
import AdminView from './components/AdminView';
import NovyTiket from './components/NovyTiket';
import PrehledTiketu from './components/PrehledTiketu';
import DetailTiketu from './components/DetailTiketu';
import CoJeNoveho from './components/CoJeNoveho';
import { getStoredRole, isTokenExpired, clearStoredRole, getTokenPayload, jeDispecerTechnik } from './auth';
import { roleStitek } from './tiketyConst';

const SIROKE_STRANKY = ['admin', 'moje-tikety', 'tiket-detail', 'aktivni-tikety', 'co-je-noveho'];
const API = process.env.REACT_APP_API_URL || '/api';

// Patička s verzí z backendu (/api/version) — vidět i na přihlašovací stránce.
function VerzePaticka() {
  const [v, setV] = useState(null);
  useEffect(() => {
    axios.get(`${API}/version`).then(res => setV(res.data)).catch(() => {});
  }, []);
  if (!v) return null;
  const text = v.version === 'dev' ? 'verze dev' : `verze ${v.version} · ${v.commit}`;
  return (
    <div style={{ textAlign: 'center', fontSize: '11px', color: '#9ca3af', padding: '12px 16px 20px' }}>{text}</div>
  );
}

// Odkaz z notifikace: /?tiket=<id>. Parametr se drží, dokud se uživatel nepřihlásí, pak se otevře detail.
function tiketZUrl() {
  const id = new URLSearchParams(window.location.search).get('tiket');
  return /^\d+$/.test(id || '') ? Number(id) : null;
}

function odeberTiketZUrl() {
  const params = new URLSearchParams(window.location.search);
  params.delete('tiket');
  const qs = params.toString();
  window.history.replaceState(null, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
}

function App() {
  const [role, setRole] = useState(() => {
    if (isTokenExpired()) { clearStoredRole(); return null; }
    return getStoredRole();
  });
  const [stranka, setStranka] = useState('rozcesti');
  const [vybranyId, setVybranyId] = useState(null);
  const [adminTab, setAdminTab] = useState(null);
  const [cekajiciTiket, setCekajiciTiket] = useState(tiketZUrl);

  const naviguj = (cil, id = null, tab = null) => {
    setVybranyId(id);
    if (tab) setAdminTab(tab);
    setStranka(cil);
  };

  useEffect(() => {
    if (cekajiciTiket === null || !role) return;
    if (isTokenExpired()) return;
    setCekajiciTiket(null);
    odeberTiketZUrl();
    setVybranyId(cekajiciTiket);
    setStranka('tiket-detail');
  }, [role, cekajiciTiket]);

  const handleSetRole = (novaRole) => {
    setRole(novaRole);
    setStranka('rozcesti');
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      {stranka !== 'rozcesti' && (
        <div style={{
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #e0e0e0',
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <img src="/logo.png" alt="ENTSOL" style={{ height: '40px' }} />
          <span style={{ fontSize: '18px', fontWeight: 'bold', color: '#333333' }}>Servisní zásahy</span>
          {(() => {
            const me = getTokenPayload();
            if (!me) return null;
            return (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#333333' }}>
                <strong>{me.jmeno}</strong>
                <span style={{ background: '#3ab54a', color: '#fff', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', fontWeight: 'bold' }}>{roleStitek(me)}</span>
              </span>
            );
          })()}
        </div>
      )}
      <div style={{
        maxWidth: SIROKE_STRANKY.includes(stranka) ? '960px' : '600px',
        margin: '0 auto',
        padding: '20px 16px',
      }}>
        {stranka === 'rozcesti'      && <Rozcesti role={role} setRole={handleSetRole} setStranka={setStranka} naviguj={naviguj} />}
        {stranka === 'novy-tiket'     && ['dispecer', 'admin'].includes(role) && <NovyTiket setStranka={setStranka} naviguj={naviguj} navazujeNaId={vybranyId} />}
        {stranka === 'aktivni-tikety' && role !== 'technik' && <PrehledTiketu setStranka={setStranka} naviguj={naviguj} />}
        {stranka === 'moje-tikety'    && (role === 'technik' || jeDispecerTechnik()) && <PrehledTiketu setStranka={setStranka} naviguj={naviguj} rezim="technik" nadpis="Tikety" />}
        {stranka === 'tiket-detail'   && <DetailTiketu key={vybranyId} tiketId={vybranyId} naviguj={naviguj} role={role} />}
        {stranka === 'co-je-noveho'   && ['dispecer', 'admin'].includes(role) && <CoJeNoveho setStranka={setStranka} />}
        {stranka === 'admin'         && role === 'admin' && <AdminView setStranka={setStranka} naviguj={naviguj} initialTab={adminTab} />}
      </div>
      <VerzePaticka />
    </div>
  );
}

export default App;
